/*
 * @Author: 王枫叶
 * @Date: 2020-10-30 14:43:04
 * @LastEditors: 王枫叶
 * @LastEditTime: 2020-12-18 11:31:13
 */
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import ElementUI from "element-ui";
import Router from "vue-router";
import "./assets/scss/element-variables.scss";
import "./permission";
Vue.prototype.$store = store;
// 引入lodash
import _ from "lodash";
Vue.prototype._ = _;
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

// 全局路由
Vue.use(Router);
// 引入element-ui
Vue.use(ElementUI);
//阻止启动生产模式的消息
Vue.config.productionTip = false;

const vue = new Vue({
  router,
  store, // 注册store选项  把 store 对象提供给 “store” 选项，实现把 store 的实例注入所有的子组件
  render: (h) => h(App), //生成VNodes树<=>虚拟DOM
}).$mount("#app");

export default vue;
